(() => {
  // Modelos editáveis: acrescente uma entrada para Babylook e outros cortes.
  // Informe os valores usados na opção Modelo e as medidas da peça em centímetros.
  const models = [
    {
      label: 'Camiseta tradicional', values: ['camiseta', 'tradicional', 'regular'], ease: 16,
      path: 'M229.000 64.410 C 227.075 65.137,222.922 66.945,219.772 68.429 C 215.880 70.262,211.072 71.458,204.772 72.159 C 199.672 72.727,191.900 74.040,187.500 75.077 C 183.100 76.114,170.137 78.549,158.694 80.489 C 137.378 84.103,129.506 86.209,120.588 90.683 C 114.368 93.804,110.600 96.832,93.609 112.364 C 78.488 126.186,46.360 154.460,37.684 161.580 C 30.984 167.079,29.000 170.328,29.000 175.802 C 29.000 180.927,29.837 182.027,59.464 215.849 C 90.991 251.841,93.962 254.462,102.250 253.592 L 107.000 253.094 107.003 269.797 C 107.008 292.852,105.477 334.858,101.798 412.627 C 99.983 451.011,99.023 449.701,130.393 451.654 C 142.002 452.376,170.400 453.422,193.500 453.977 C 216.600 454.531,239.775 455.429,245.000 455.971 C 263.066 457.845,305.176 458.325,348.339 457.150 C 372.078 456.503,393.943 455.537,396.929 455.002 C 403.426 453.839,407.673 450.258,408.635 445.132 C 408.998 443.198,408.784 434.614,408.159 426.057 C 407.535 417.501,406.556 398.125,405.984 383.000 C 405.411 367.875,404.521 348.525,404.006 340.000 C 403.491 331.475,402.608 313.700,402.045 300.500 C 401.481 287.300,400.728 272.183,400.370 266.906 L 399.719 257.312 405.196 257.766 C 408.922 258.075,411.604 257.734,413.586 256.699 C 418.109 254.338,434.427 238.882,448.099 224.011 C 454.919 216.592,465.099 205.890,470.719 200.230 C 483.044 187.816,484.481 184.691,481.088 177.681 C 478.290 171.902,405.105 97.933,396.849 92.540 C 393.741 90.509,387.370 87.570,382.691 86.008 C 368.242 81.184,331.413 74.092,304.723 70.994 C 299.345 70.370,291.695 68.723,287.723 67.335 C 280.513 64.815,280.473 64.813,265.955 66.070 C 252.066 67.273,251.029 67.232,242.923 65.165 C 233.104 62.661,233.565 62.686,229.000 64.410 M244.000 75.495 C 250.540 77.258,252.642 77.250,272.117 75.382 C 277.658 74.851,280.017 75.168,286.617 77.333 C 290.953 78.754,299.225 80.405,305.000 81.001 C 318.825 82.427,347.112 87.279,363.438 91.024 C 383.829 95.702,388.518 97.848,399.255 107.420 C 411.132 118.008,470.936 178.825,472.230 181.631 C 473.093 183.502,472.126 184.848,464.327 192.631 C 459.440 197.509,449.472 208.025,442.176 216.000 C 428.803 230.617,409.549 248.986,407.570 249.016 C 406.981 249.025,402.805 247.133,398.288 244.812 C 393.772 242.490,389.789 240.878,389.438 241.229 C 389.086 241.580,389.506 253.260,390.370 267.184 C 391.234 281.108,392.423 303.975,393.012 318.000 C 393.601 332.025,394.501 348.912,395.011 355.526 C 395.522 362.140,396.191 377.665,396.497 390.026 C 397.002 410.381,398.465 434.210,399.540 439.588 C 399.769 440.737,399.329 442.537,398.562 443.588 C 397.310 445.304,395.284 445.569,378.833 446.171 C 337.338 447.689,271.387 448.178,258.000 447.068 C 250.575 446.452,227.175 445.524,206.000 445.007 C 169.444 444.115,115.121 441.464,112.093 440.425 C 110.573 439.904,110.865 421.549,112.991 383.981 C 114.587 355.761,116.992 280.226,116.996 258.183 L 117.000 237.865 114.750 238.529 C 113.513 238.894,110.083 240.274,107.129 241.596 C 104.175 242.918,100.967 244.000,100.000 244.000 C 99.033 244.000,95.375 240.949,91.871 237.220 C 81.660 226.353,62.102 204.257,54.057 194.500 C 49.976 189.550,44.698 183.387,42.329 180.804 C 39.640 177.873,38.242 175.533,38.608 174.578 C 38.931 173.736,43.582 169.324,48.942 164.774 C 67.802 148.763,86.420 132.354,101.781 118.204 C 110.316 110.342,119.209 102.790,121.543 101.422 C 130.023 96.452,138.682 93.908,159.000 90.417 C 170.275 88.479,182.425 86.220,186.000 85.396 C 189.575 84.572,197.225 83.255,203.000 82.470 C 216.918 80.575,219.446 79.893,226.510 76.119 C 232.935 72.686,233.504 72.666,244.000 75.495 ',
      sizes: [
        { size: 'P', length: 67, width: 52 }, { size: 'M', length: 75, width: 52 },
        { size: 'G', length: 76, width: 56 }, { size: 'GG', length: 77, width: 59 },
        { size: 'XG', length: 78, width: 61 }
      ]
    },
    {
      label: 'Camiseta oversized', values: ['oversized', 'over-sized', 'oversize'], ease: 20,
      path: 'M273.000 61.444 C 255.679 70.918,237.746 71.843,224.640 63.939 C 213.611 57.287,208.625 58.187,186.130 70.895 C 179.904 74.412,170.465 79.194,165.155 81.521 C 134.612 94.907,126.632 98.470,118.500 102.354 C 113.550 104.719,106.125 108.259,102.000 110.223 C 97.875 112.186,90.000 115.687,84.500 118.002 C 79.000 120.318,63.700 127.756,50.500 134.533 C 37.300 141.310,24.475 147.637,22.000 148.593 C 14.992 151.300,12.155 153.710,11.022 157.917 C 9.645 163.032,9.964 163.837,27.463 199.500 C 35.559 216.000,43.942 234.028,46.093 239.561 C 50.418 250.693,54.263 255.584,59.456 256.558 C 63.441 257.305,71.320 254.339,88.500 245.625 C 105.677 236.912,104.314 237.216,103.646 242.243 C 101.633 257.410,99.485 428.361,101.240 433.788 C 101.647 435.047,103.175 437.184,104.636 438.538 L 107.292 441.000 148.396 440.978 C 215.261 440.942,311.372 438.846,380.500 435.916 C 408.570 434.726,410.133 434.395,414.333 428.760 L 416.375 426.021 414.664 390.260 C 413.722 370.592,412.504 339.425,411.957 321.000 C 411.410 302.575,410.524 276.925,409.987 264.000 C 409.451 251.075,409.009 239.030,409.006 237.233 L 409.000 233.966 413.979 236.489 C 420.569 239.829,427.473 242.326,439.000 245.539 C 450.131 248.643,455.796 248.458,459.688 244.866 C 465.289 239.696,489.350 200.124,497.968 181.907 C 503.467 170.281,501.925 166.294,489.273 159.422 C 476.342 152.399,457.309 141.393,442.000 132.086 C 434.575 127.572,421.075 120.245,412.000 115.804 C 402.925 111.364,388.975 104.022,381.000 99.490 C 361.305 88.296,341.660 78.566,320.341 69.445 C 302.235 61.697,297.033 60.245,284.500 59.435 C 278.439 59.043,276.896 59.313,273.000 61.444 M293.500 69.861 C 303.761 71.518,347.850 91.517,372.500 105.696 C 380.200 110.125,395.197 118.100,405.827 123.418 C 416.456 128.736,434.006 138.407,444.827 144.909 C 455.647 151.411,470.462 159.996,477.750 163.987 C 487.992 169.596,491.000 171.703,491.000 173.267 C 491.000 178.372,456.519 236.819,452.626 238.313 C 450.734 239.039,429.507 233.084,421.735 229.646 C 418.616 228.267,412.886 225.082,409.001 222.569 C 405.116 220.056,401.510 218.000,400.988 218.000 C 398.936 218.000,398.715 224.527,399.856 251.476 C 400.509 266.889,401.483 292.438,402.021 308.250 C 404.154 370.893,405.133 395.051,406.044 407.500 C 406.567 414.650,406.996 421.299,406.998 422.275 C 407.002 425.861,412.647 425.514,289.500 429.494 C 264.750 430.294,214.350 431.073,177.500 431.225 L 110.500 431.500 110.536 376.500 C 110.576 316.111,112.358 245.553,114.055 237.119 C 114.760 233.617,114.797 231.397,114.161 230.761 C 113.624 230.224,110.258 229.550,106.682 229.263 C 100.426 228.760,99.862 228.913,91.839 233.277 C 82.439 238.391,63.396 247.000,61.486 247.000 C 59.610 247.000,57.692 243.533,53.741 233.000 C 51.782 227.775,43.380 209.775,35.071 193.000 C 26.762 176.225,20.085 161.963,20.232 161.307 C 20.539 159.938,77.841 131.189,94.819 123.886 C 101.044 121.208,107.107 118.338,108.291 117.509 C 109.476 116.679,111.409 116.000,112.588 116.000 C 113.766 116.000,115.899 115.081,117.328 113.957 C 119.791 112.019,131.127 106.824,164.000 92.566 C 171.975 89.107,184.450 82.902,191.721 78.777 C 198.993 74.651,206.946 70.715,209.395 70.029 C 213.717 68.819,214.017 68.887,219.673 72.360 C 234.465 81.440,254.181 81.126,274.074 71.495 C 279.883 68.683,282.262 68.025,285.000 68.477 C 286.925 68.794,290.750 69.417,293.500 69.861 ',
      sizes: [
        { size: 'P', length: 74, width: 53 }, { size: 'M', length: 76.5, width: 56 },
        { size: 'G', length: 78, width: 60 }, { size: 'GG', length: 79, width: 61.5 },
        { size: 'XG', length: 79, width: 64 }
      ]
    }
    // Babylook: copie um bloco acima, inclua a palavra 'babylook' em values,
    // adicione o SVG no path e preencha as medidas reais quando estiverem definidas.
  ];
  const normalize = (value) => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

  class SizeAdvisor extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.chartDialog = this.querySelector('[data-chart-dialog]');
      this.advisorDialog = this.querySelector('[data-advisor-dialog]');
      this.form = this.querySelector('[data-advisor-form]');
      this.sizeInput = this.querySelector('[data-size-value]');
      this.sizePickerBox = this.querySelector('.size-advisor__picker');
      this.result = this.querySelector('[data-result]');
      this.status = this.querySelector('[data-size-status]');
      this.modelValue = this.getCurrentModelValue();
      this.model = this.getModelForValue(this.modelValue);
      this.restoreFormInputs();
      this.renderSizeButtons();
      this.renderChart();
      this.restoreSelection();
      this.restoreSavedRecommendation();

      this.querySelector('[data-open-chart]')?.addEventListener('click', () => this.open(this.chartDialog), { signal });
      this.querySelector('[data-open-advisor]')?.addEventListener('click', () => this.open(this.advisorDialog), { signal });
      this.querySelectorAll('[data-close]').forEach((button) => button.addEventListener('click', () => button.closest('dialog')?.close(), { signal }));
      this.querySelectorAll('dialog').forEach((dialog) => dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      }, { signal }));
      this.form?.addEventListener('submit', (event) => this.recommend(event), { signal });
      this.profileInputHandler = () => {
        this.saveFormInputs();
        this.clearRecommendations();
      };
      this.form?.addEventListener('input', this.profileInputHandler, { signal });
      this.form?.addEventListener('change', this.profileInputHandler, { signal });
      this.variantChangeHandler = (event) => {
        const picker = event.target?.closest?.('variant-selects');
        if (!picker || picker.id !== this.dataset.variantPickerId) return;
        this.updateModel();
        requestAnimationFrame(() => this.updateModel());
      };
      document.addEventListener('change', this.variantChangeHandler, { capture: true, signal });

      this.formElement = document.getElementById(this.dataset.formId);
      this.submitHandler = (event) => {
        if (this.sizeInput?.value) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.requireSelection();
      };
      this.formElement?.addEventListener('submit', this.submitHandler, { capture: true, signal });
      this.clickGuard = (event) => {
        if (this.sizeInput?.value) return;
        const submitter = event.composedPath().find((node) => node instanceof Element && node.matches('button[type="submit"], input[type="submit"], button[name="add"]'));
        if (!submitter) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.requireSelection();
      };
      this.formElement?.addEventListener('click', this.clickGuard, { capture: true, signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.errorTimer) clearTimeout(this.errorTimer);
    }

    open(dialog) { if (dialog?.showModal) dialog.showModal(); }

    sizeStorageKey() { return `dilly-size:${window.location.pathname}:${this.dataset.formId}`; }
    profileStorageKey() { return `dilly-size-profile:${window.location.pathname}:${this.dataset.formId}`; }
    recommendationStorageKey() { return `dilly-size-recommendations:${window.location.pathname}:${this.dataset.formId}`; }

    profileValues() {
      const value = (name) => this.form?.elements.namedItem(name)?.value || '';
      return { sex: value('sex'), height: value('height'), weight: value('weight'), chest: value('chest'), fit: value('fit') };
    }

    profileFingerprint(values = this.profileValues()) { return JSON.stringify(values); }

    restoreFormInputs() {
      try {
        const values = JSON.parse(sessionStorage.getItem(this.profileStorageKey()) || 'null');
        if (!values || !this.form) return;
        if (values.fit === 'close') {
          values.fit = 'standard';
          sessionStorage.setItem(this.profileStorageKey(), JSON.stringify(values));
          sessionStorage.removeItem(this.recommendationStorageKey());
        }
        for (const [name, value] of Object.entries(values)) {
          const field = this.form.elements.namedItem(name);
          if (field) field.value = value;
        }
      } catch (_) {}
    }

    saveFormInputs() {
      try { sessionStorage.setItem(this.profileStorageKey(), JSON.stringify(this.profileValues())); } catch (_) {}
    }

    clearRecommendations() {
      try { sessionStorage.removeItem(this.recommendationStorageKey()); } catch (_) {}
      if (this.result) {
        this.result.hidden = true;
        this.result.replaceChildren();
      }
    }

    restoreSelection() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.sizeStorageKey()) || 'null');
        if (!saved) return;
        const validSize = !this.model || this.model.sizes.some((item) => item.size === saved.size);
        if (saved.model === this.modelValue && validSize) this.chooseSize(saved.size);
        else sessionStorage.removeItem(this.sizeStorageKey());
      } catch (_) {}
    }

    saveSelection() {
      try {
        if (!this.sizeInput?.value) sessionStorage.removeItem(this.sizeStorageKey());
        else sessionStorage.setItem(this.sizeStorageKey(), JSON.stringify({ model: this.modelValue, size: this.sizeInput.value }));
      } catch (_) {}
    }

    requireSelection() {
      this.status.textContent = 'Escolha P, M, G, GG ou XG antes de adicionar ao carrinho.';
      this.sizePickerBox?.classList.remove('size-advisor__picker--error');
      void this.sizePickerBox?.offsetWidth;
      this.sizePickerBox?.classList.add('size-advisor__picker--error');
      if (this.errorTimer) clearTimeout(this.errorTimer);
      this.errorTimer = setTimeout(() => this.sizePickerBox?.classList.remove('size-advisor__picker--error'), 1800);
      this.querySelector('[data-size]')?.focus();
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    getCurrentModelValue() {
      const picker = document.getElementById(this.dataset.variantPickerId);
      const controls = [...(picker?.querySelectorAll('input[data-option-name], select[name^="options["]') || [])];
      let selected = '';
      for (const control of controls) {
        const optionName = control.dataset.optionName || control.name || '';
        if (!normalize(optionName).includes('modelo') && !normalize(optionName).includes('model')) continue;
        if (control.type === 'radio' && !control.checked) continue;
        selected = control.value;
        break;
      }
      return normalize(selected) || normalize(models[0].values[0]);
    }

    getModelForValue(modelValue) {
      return models.find((model) => model.values.some((value) => modelValue.includes(normalize(value)))) || null;
    }

    updateModel() {
      const nextValue = this.getCurrentModelValue();
      if (nextValue === this.modelValue) return;
      this.modelValue = nextValue;
      this.model = this.getModelForValue(nextValue);
      this.renderSizeButtons();
      this.renderChart();
      this.chooseSize('');
      this.restoreSavedRecommendation();
    }

    renderSizeButtons() {
      const container = this.querySelector('[data-size-buttons]');
      if (!container) return;
      const sizes = this.model?.sizes.map((item) => item.size) || ['P', 'M', 'G', 'GG', 'XG'];
      container.innerHTML = sizes.map((size) => `<button type="button" class="size-advisor__size" data-size="${size}" aria-pressed="${this.sizeInput?.value === size}">${size}</button>`).join('');
      container.querySelectorAll('[data-size]').forEach((button) => button.addEventListener('click', () => this.chooseSize(button.dataset.size), { signal: this.controller?.signal }));
    }

    chooseSize(size) {
      this.sizeInput.value = size;
      this.querySelectorAll('[data-size]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.size === size)));
      this.querySelector('[data-selected-label]').textContent = size || 'Selecione';
      this.status.textContent = size ? `Tamanho ${size} selecionado.` : 'Selecione um tamanho para continuar.';
      this.sizePickerBox?.classList.remove('size-advisor__picker--error');
      if (this.errorTimer) clearTimeout(this.errorTimer);
      this.saveSelection();
    }

    renderChart() {
      const target = this.querySelector('[data-chart-content]');
      if (!target) return;
      if (!this.model) {
        target.innerHTML = '<p class="size-advisor__note">Este modelo ainda não tem uma tabela configurada. Para adicioná-la, inclua as medidas e o SVG do modelo no objeto <code>models</code> de <code>assets/size-advisor.js</code>.</p>';
        return;
      }
      const rows = this.model.sizes.map((item) => `<tr><th scope="row">${item.size}</th><td>${this.format(item.length)}</td><td>${this.format(item.width)}</td></tr>`).join('');
      target.innerHTML = `<p class="size-advisor__note">${this.model.label} · medidas da peça em centímetros.</p><div class="size-advisor__diagram"><svg viewBox="0 0 514 514" role="img" aria-label="Desenho da camiseta com indicações de comprimento e largura"><path d="${this.model.path}" fill="rgba(var(--color-foreground),.07)" stroke="currentColor" stroke-width="5"/><g fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"><path d="M132 145v275m-10-260 10-16 10 16m-20 245 10 16 10-16M145 475h225m-208-10-17 10 17 10m191-20 17 10-17 10"/></g></svg><div class="size-advisor__diagram-caption"><p><strong>Comprimento:</strong> do ponto mais alto do ombro até a barra.</p><p><strong>Largura:</strong> de uma lateral à outra, na altura do tórax.</p><p>A largura é medida com a camiseta aberta. Para comparar ao tórax, multiplique a largura por 2.</p></div></div><h3 class="size-advisor__table-title">Tabela de medidas</h3><div class="size-advisor__table-scroll"><table><thead><tr><th>Tamanho</th><th>Comprimento</th><th>Largura</th></tr></thead><tbody>${rows}</tbody></table></div><p class="size-advisor__note size-advisor__note--bottom">As medidas podem variar alguns centímetros entre peças. Se você já tem uma camiseta confortável, compare-a aberta com esta tabela.</p>`;
    }

    recommend(event) {
      event.preventDefault();
      if (!this.model) {
        this.result.innerHTML = '<p>O recomendador deste modelo ainda precisa de uma tabela de medidas.</p>';
        this.result.hidden = false;
        return;
      }
      const data = new FormData(event.currentTarget);
      const height = Number(data.get('height'));
      const weight = Number(data.get('weight'));
      const chest = Number(data.get('chest')) || null;
      const sex = data.get('sex');
      const fit = data.get('fit');
      const index = this.pickSize({ height, weight, chest, sex, fit });
      const recommendation = { size: this.model.sizes[index].size, height, weight, chest, sex, fit };
      this.saveRecommendation(recommendation);
      this.renderRecommendation(recommendation);
      this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    saveRecommendation(recommendation) {
      try {
        const fingerprint = this.profileFingerprint();
        let saved = JSON.parse(sessionStorage.getItem(this.recommendationStorageKey()) || 'null');
        if (!saved || saved.fingerprint !== fingerprint) saved = { fingerprint, byModel: {} };
        saved.byModel[this.modelValue] = recommendation;
        sessionStorage.setItem(this.recommendationStorageKey(), JSON.stringify(saved));
      } catch (_) {}
    }

    restoreSavedRecommendation() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.recommendationStorageKey()) || 'null');
        if (!saved) return;
        if (saved.fingerprint !== this.profileFingerprint()) {
          sessionStorage.removeItem(this.recommendationStorageKey());
          return;
        }
        const recommendation = saved.byModel?.[this.modelValue];
        if (recommendation && this.model) this.renderRecommendation(recommendation);
        else {
          this.result.hidden = true;
          this.result.replaceChildren();
        }
      } catch (_) {}
    }

    renderRecommendation(recommendation) {
      if (!this.model) return;
      const { size, height, weight, chest, sex, fit } = recommendation;
      const index = this.model.sizes.findIndex((item) => item.size === size);
      if (index < 0) return;
      const recommended = this.model.sizes[index];
      const details = this.model.sizes.map((item, i) => `<li><strong>${item.size}:</strong> ${this.fitDescription(item, i, index, height, chest)} · peça ${this.format(item.length)} cm × ${this.format(item.width)} cm (comprimento × largura).</li>`).join('');
      const method = chest ? `Sua medida de tórax (${this.format(chest)} cm) foi comparada com a largura desta peça.` : 'Sem a medida do tórax, a indicação usa altura, peso e a referência de sexo como estimativa geral.';
      this.result.innerHTML = `<h3>Sugestão: ${recommended.size}</h3><p>${method}</p><p>${this.model.label}. ${this.lengthDescription(recommended, height)}</p><p>Caimento estimado por tamanho:</p><ul>${details}</ul><button type="button" data-apply-size>Selecionar tamanho ${recommended.size}</button>`;
      this.result.hidden = false;
      this.result.querySelector('[data-apply-size]')?.addEventListener('click', () => { this.chooseSize(recommended.size); this.advisorDialog.close(); }, { signal: this.controller?.signal });
    }

    pickSize({ height, weight, chest, sex, fit }) {
      const sizes = this.model.sizes;
      if (chest) {
        const ease = fit === 'loose' ? this.model.ease + 4 : this.model.ease;
        let found = sizes.findIndex((item) => item.width * 2 >= chest + ease);
        if (found < 0) found = sizes.length - 1;
        if (height >= 187 && found < sizes.length - 1) found += 1;
        return found;
      }
      const bmi = weight / ((height / 100) ** 2);
      const thresholds = sex === 'male' ? [20, 23.5, 27, 31] : sex === 'female' ? [19, 22.5, 26, 30] : [19.5, 23, 26.5, 30.5];
      let index = thresholds.findIndex((threshold) => bmi < threshold);
      if (index < 0) index = sizes.length - 1;
      if (height >= 187) index += 1;
      else if (height <= 155) index -= 1;
      if (fit === 'loose') index += 1;
      return Math.max(0, Math.min(sizes.length - 1, index));
    }

    fitDescription(item, itemIndex, recommendedIndex, height, chest) {
      const length = this.lengthDescription(item, height).toLowerCase();
      if (chest) {
        const ease = item.width * 2 - chest;
        const torso = ease < 0 ? 'pode ficar apertada no tórax' : ease < 6 ? 'caimento justo' : ease < 12 ? 'próxima ao corpo' : ease < 21 ? 'caimento confortável' : 'caimento bem amplo';
        return `${torso}; ${length}`;
      }
      const distance = itemIndex - recommendedIndex;
      const torso = distance <= -2 ? 'tende a ficar justa' : distance === -1 ? 'mais próxima ao corpo' : distance === 0 ? (this.model.values.includes('oversized') ? 'caimento oversized equilibrado' : 'caimento estimado padrão') : distance === 1 ? 'mais folgada' : 'bem ampla';
      return `${torso}; ${length}`;
    }

    lengthDescription(item, height) {
      const ratio = item.length / height;
      if (ratio < .385) return 'O comprimento tende a ficar mais curto na sua altura.';
      if (ratio > .455) return 'O comprimento tende a ficar mais alongado na sua altura.';
      return 'O comprimento tende a ficar equilibrado para sua altura.';
    }

    format(value) { return String(value).replace('.', ','); }
  }
  if (!customElements.get('size-advisor')) customElements.define('size-advisor', SizeAdvisor);
})();
